import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Group } from '@era/security-sdk';
import { UserGroupStoreActions, UserGroupStoreSelectors, UserStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { ListGroupItemsComponent } from './list-group-items.component';

@Component({
  selector: 'era-security-membership-list-group-items',
  templateUrl: 'membership-list-group-items.container.html',
  styleUrls: ['./membership-list-group-items.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ListGroupItemsComponent],
})
export class MembershipListGroupItemsContainerComponent {
  private readonly store = inject(Store);

  readonly isEditing = input(false);

  public readonly user = this.store.selectSignal(UserStoreSelectors.selectCurrentUser);
  public readonly userGroups = this.store.selectSignal(UserGroupStoreSelectors.selectCurrentUserMemberships);

  delete(selectedGroup: Group) {
    const currentUser = this.user();
    if (!currentUser) return;
    this.store.dispatch(
      UserGroupStoreActions.MembershipListUIActions.userGroupDeleted({
        group: selectedGroup,
        user: currentUser,
      })
    );
  }
}
